import { Link } from 'react-router-dom';
import { categories } from '@/mocks/nodes';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-rocket-line text-lg text-white"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">节点指南</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              每日更新稳定可用的免费节点资源，提供专业的使用教程与安全指南。帮助每一位用户轻松获取优质的节点体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">快捷导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-white transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-white transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-white transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">免责声明</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              本网站仅提供节点资源信息与技术教程，不提供任何形式的代理服务。用户使用节点时请遵守当地法律法规，本网站不对用户的使用行为承担任何责任。
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 节点指南 - 免费节点获取指南·每日更新稳定可用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}